<template>
    <div>
        <div class="chart">
            <svg
                width="200"
                height="200"
                viewPort="0 0 100 100"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
            >
                <circle
                    r="90"
                    cx="100"
                    cy="100"
                    fill="transparent"
                    stroke-dasharray="565.48"
                    stroke-dashoffset="0"
                    :style="{
                strokeDashoffset    :   style.size ,
                stroke              :   style.color
            }"
                />
                <text
                    x="100"
                    y="-110"
                    text-anchor="middle"
                    alignment-baseline="central"
                    :fill="style.color"
                    style="transform: rotate(90deg);"
                    v-text="step"
                />
                <text
                    x="100"
                    y="-77"
                    fill="#707070"
                    text-anchor="middle"
                    alignment-baseline="central"
                    style="transform: rotate(90deg);"
                    v-text="client"
                />
            </svg>
        </div>
    </div>
</template>

<script>
// import merge from 'lodash-es/merge';

export default {
    name: "radial-progress-v3",
    props: ["options", "client"],
    data() {
        return {
            style: {
                color: "",
                size: ""
            },
            step: this.options.step
        };
    },
    mounted() {
        var c = Math.PI * (90 * 2);
        /* populate values without efects */
        //this.style.size = (((100-this.options.step)/100)*c) + "px"
        this.style.color = this.options.color;

        /* populate values with efects */
        var vm = this;
        var counter = 0;
        var timer = setInterval(function() {
            if (counter > vm.options.step) {
                clearInterval(timer);
            } else {
                vm.style.size = ((100 - counter) / 100) * c + "px";
                vm.step = counter;
            }
            counter++;
        }, 30);
    }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
svg {
    transform: rotate(270deg);
    circle {
        stroke-dashoffset: 0;
        transition: stroke-dashoffset 1s linear;
        stroke: #666;
        stroke-width: 1.3em;
    }
    text {
        &:nth-child(2) {
            font-size: 2.5em;
            font-weight: bolder;
            letter-spacing: 2px;
        }
        &:nth-child(3) {
            font-size: 1.2em;
        }
    }
}

.chart {
    zoom: 0.7;
    margin-bottom: 0.8rem;
    display: inline-block;
    height: 200px;
    width: 200px;
    border-radius: 100%;
    position: relative;
    background: #cbe8ef;
    text-align: center;

    &:before {
        position: absolute;
        display: block;
        height: 160px;
        width: 160px;
        left: 50%;
        top: 50%;
        content: "";
        margin-top: -80px;
        margin-left: -80px;
        border-radius: 100%;
        line-height: 160px;
        background: #fff;
    }
}
</style>


// WEBPACK FOOTER //
// resources/office/js/components/franchise_v4/rank/components/radialProgress.vue